<template>
  <div class="main_container">
    <NavBar/>
    <div class="main_home">
      <section>
        <div class="main_home-background">
          <div class="main_home-content">
            <div class="main_home-title">
              Find the Perfect Stay or Manage Your Property with Ease
            </div>
            <div class="main_home-description">
              List your property, manage bookings, and sync with Airbnb, or discover unique stays and book directly
            </div>
          </div>
          <div class="main_search-container">
            <div class="main_search-block">
              <div class="main_search-box autocomplete-box">
                <label>Where</label>
                <input
                    type="text"
                    placeholder="Search destination"
                    v-model="searchData.city"
                    @input="onInputCity"
                    @focus="showSuggestions = true"
                    @blur="hideSuggestions"
                />
                <ul v-if="showSuggestions && citySuggestions.length" class="autocomplete-list">
                  <li
                      v-for="(suggestion, index) in citySuggestions"
                      :key="index"
                      @mousedown.prevent="selectCity(suggestion)"
                  >
                    {{ suggestion.place_name }}
                  </li>
                </ul>
              </div>
              <span class="input_divider"></span>
              <div class="main_search-box">
                <md-datepicker class="mb-1 info-datepicker" v-model="startDate" :min="today" >
                  <label>Check in</label>
                </md-datepicker>
<!--                <label>Check in</label>-->
<!--                <input type="date" placeholder="Add dates" v-model="searchData.start" :min="today"/>-->
              </div>
              <span class="input_divider"></span>
              <div class="main_search-box">

                <md-datepicker class="mb-1 info-datepicker" v-model="endDate" :min="searchData.start || today" >
                  <label>Check out</label>
                </md-datepicker>
<!--                <label>Check out</label>-->
<!--                <input type="date" placeholder="Add dates" v-model="searchData.end" :min="searchData.start || today"/>-->
              </div>
              <span class="input_divider"></span>
              <div class="main_search-box">
                <label>Guests</label>
                <input type="number" placeholder="Add guest" v-model="searchData.numberOfGuests"/>
              </div>
              <button class="main_search-btn" @click="onSelect()"></button>
            </div>
            <p v-if="result_error" class="result_error-text">{{ result_error }}</p>
          </div>
          <p class="main_sub">
            <span class="main_sub-icon"></span>&nbsp;Search deals on hotels, homes, and much more...
          </p>
        </div>
      </section>
      <section v-if="serchResults.length">
        <div class="main_section top_deals" ref="search_results">
          <div class="select_content">
            <h3 class="top_title">Search results</h3>
            <div v-if="serchResults.length" class="select_box">
              <Multiselect
                  v-model="filter_value"
                  tag-placeholder="Add this as new tag"
                  placeholder="Select amenities"
                  label="name"
                  track-by="val"
                  :options="amenities_options"
                  :multiple="true"
                  :taggable="true"
                  @select="onSelect"
                  @remove="onSelect"
              >
              </Multiselect>
            </div>
          </div>

          <div class="top_deals search_results">
            <carousel
                v-if="serchResults.length"
                :dots="true"
                :responsiveClass="true"
                :items="4"
                :center="false"
                :loop="false"
                :autoplay="false"
                :autoplayHoverPause="true"
                :navText="['<','>']"
                :rewind="true"
                :responsive="{0:{items:1},576:{items:1},768:{items:2}, 1024:{items:2}, 1200:{items:2}, 1440:{items:3}, 1600:{items:3},1700:{items:4}}"
            >
              <div class="top_carousel-item" v-for="(slideItem, index) in serchResults" :key="`search-result-${slideItem.id || slideItem.listing_id || index}-${slideItem.external_listing_name || ''}`" @click="showListing(slideItem)">
                <b-carousel
                    fade
                    indicators
                    img-width="405"
                    img-height="605"
                >
                  <template v-if="slideItem.images && slideItem.images.length">
                    <b-carousel-slide
                        v-for="(item, i) in slideItem.images"
                        :key="`image-${slideItem.id || slideItem.listing_id || index}-${i}-${item.url || ''}`"
                        :img-src="item.url"
                    >
                      <div class="carousel-info-overlay">
                        <div class="carousel-info-content">
                          <h4 class="carousel-title">{{ slideItem.external_listing_name }}</h4>
                          <p class="carousel-text">
                            <md-icon>location_on</md-icon>
                              {{ formatAddress(slideItem) }}
                          </p>
                          <p class="carousel-price">{{ getCurrencySymbol(slideItem.price_and_fee.currency_code) }}
                            {{ slideItem.price_and_fee.price || 0 }}</p>
                          <p class="carousel-text">Per night</p>
                        </div>
                      </div>
                    </b-carousel-slide>
                  </template>
                  <b-carousel-slide v-else class="empty_slide">
                    <img :src="emptyImg" alt="No image available"/>
                    <div class="carousel-info-overlay">
                      <div class="carousel-info-content">
                        <h4 class="carousel-title">Das rote Haus hinterm Deich</h4>
                        <p class="carousel-text">
                          <md-icon>location_on</md-icon>
                          Himpkampweg, 25813 Simonsberg, Germany
                        </p>
                        <p class="carousel-price">$ 120</p>
                        <p class="carousel-text">Per night</p>
                      </div>
                    </div>
                  </b-carousel-slide>
                </b-carousel>
              </div>
            </carousel>



<!--            <div class="top_carousel-item"-->
<!--                 v-for="(slideItem, index) in serchResults"-->
<!--                 :key="index"-->
<!--                 @click="showListing(slideItem)"-->
<!--            >-->
<!--              <b-carousel-->
<!--                  fade-->
<!--                  indicators-->
<!--                  img-width="405"-->
<!--                  img-height="605"-->
<!--              >-->
<!--                <template v-if="slideItem.images && slideItem.images.length">-->
<!--                  <b-carousel-slide-->
<!--                      v-for="(item, i) in slideItem.images"-->
<!--                      :key="i"-->
<!--                      :img-src="item.url"-->
<!--                  >-->
<!--                    <div class="carousel-info-overlay">-->
<!--                      <div class="carousel-info-content">-->
<!--                        <h4 class="carousel-title">{{ slideItem.external_listing_name }}</h4>-->
<!--                        <p class="carousel-text">-->
<!--                          <md-icon>location_on</md-icon>-->
<!--                          {{ slideItem.address.public_address }} soyth avenue-->
<!--                        </p>-->
<!--                        <p class="carousel-price">{{ getCurrencySymbol(slideItem.price_and_fee.currency_code) }}-->
<!--                          {{ slideItem.price_and_fee.price || 0 }}</p>-->
<!--                        <p class="carousel-text">Per night</p>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </b-carousel-slide>-->
<!--                </template>-->
<!--                <b-carousel-slide v-else class="empty_slide">-->
<!--                  <img :src="emptyImg" alt="No image available"/>-->
<!--                  <div class="carousel-info-overlay">-->
<!--                    <div class="carousel-info-content">-->
<!--                      <h4 class="carousel-title">Das rote Haus hinterm Deich</h4>-->
<!--                      <p class="carousel-text">-->
<!--                        <md-icon>location_on</md-icon>-->
<!--                        Himpkampweg, 25813 Simonsberg, Germany-->
<!--                      </p>-->
<!--                      <p class="carousel-price">$ 120</p>-->
<!--                      <p class="carousel-text">Per night</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </b-carousel-slide>-->
<!--              </b-carousel>-->
<!--            </div>-->
          </div>
        </div>
      </section>
      <section>
        <div class="main_section offer">
          <div class="offer_background">
            <div class="offer_layer">
              <h2 class="offer_title">Offer of the week</h2>
              <p class="offer_description">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer
                took a galley of type and scrambled it to make a type specimen book.</p>
              <button class="offer_discover-btn">Discover Hotels</button>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div v-if="allHomeListings?.topListings?.length > 0" class="main_section top_deals">
          <h3 class="top_title">Top hotel deals just for you</h3>
          <div class="top_sub">
            <p class="top_sub-date">Showing deals for: {{ last15Days }}</p>
          </div>
          <div class="top_deals">
            <div class="top_carousel-item"
                 v-for="(slideItem, index) in allHomeListings.topListings"
                 :key="index"
                 @click="showListing(slideItem)"
            >
              <b-carousel
                  fade
                  indicators
                  img-width="405"
                  img-height="605"
              >
                <template v-if="slideItem.images && slideItem.images.length">
                  <b-carousel-slide
                      v-for="(item, i) in slideItem.images"
                      :key="i"
                      :img-src="item.url"
                  >
                    <div class="carousel-info-overlay">
                      <div class="carousel-info-content">
                        <h4 class="carousel-title">{{ slideItem.external_listing_name }}</h4>
                        <p class="carousel-text">
                          <md-icon>location_on</md-icon>
                          {{ formatAddress(slideItem) }}
                        </p>
                        <p class="carousel-price">{{ getCurrencySymbol(slideItem.price_and_fee.currency_code) }}
                          {{ slideItem.price_and_fee.price || 0 }}</p>
                        <p class="carousel-text">Per night</p>
                      </div>
                    </div>
                  </b-carousel-slide>
                </template>
                <b-carousel-slide v-else
                                  class="empty_slide"
                >
                  <img :src="emptyImg" alt="No image available"/>
                  <div class="carousel-info-overlay">
                    <div class="carousel-info-content">
                      <h4 class="carousel-title">Das rote Haus hinterm Deich</h4>
                      <p class="carousel-text">
                        <md-icon>location_on</md-icon>
                        Himpkampweg, 25813 Simonsberg, Germany
                      </p>
                      <p class="carousel-price">$ 120</p>
                      <p class="carousel-text">Per night</p>
                    </div>
                  </div>
                </b-carousel-slide>

              </b-carousel>
            </div>

          </div>
        </div>
      </section>
      <section>
        <div class="main_section news">
          <div class="d-flex justify-content-between w-100 align-items-center">
            <h3 class="main_section-title">Blog posts</h3>
          </div>
          <div class="news_box-container">
            <div class="news_box-item blogs" v-for="blog in allBlogs.slice(0, 4)" :key="blog.id || blog.title"
                 @click="routToBlog(blog)">
              <img class="item_img" :src="blog.image_url ? blog.image_url : emptyImg" alt="">
              <h4 class="news_box-description">{{ blog.title }}</h4>
            </div>
          </div>
          <div class="d-flex justify-content-end w-100">
            <p class="main_section-view" @click="viewAllPosts()">View all</p>
          </div>
        </div>
      </section>

      <section>
        <div class="main_section top_deals category">
          <h3 class="top_title">Discover your favorite new stay</h3>
          <div class="top_deals">
            <div class="top_carousel-item"
                 v-for="(slideItem, index) in allHomeListings?.groupedByCategory"
                 :key="index"
                 @click="showListingsByCategory(slideItem)"
            >
              <b-carousel
                  fade
                  img-width="405"
                  img-height="605"
              >
                <template v-if="slideItem.listings && slideItem.listings.length">
                  <b-carousel-slide
                      :img-src="slideItem.image"
                  >
                    <div class="carousel-info-overlay">
                      <div class="carousel-info-content">
                        <h4 class="carousel-title">{{ slideItem.category }}</h4>
                      </div>
                    </div>
                  </b-carousel-slide>
                </template>
              </b-carousel>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="main_section reviews">
          <h3 class="main_section-title">Guest & Host Reviews</h3>
          <div class="reviews_content">
            <carousel
                v-if="allReviews.length"
                :dots="false"
                :responsiveClass="true"
                :items="4"
                :center="true"
                :loop="true"
                :autoplay="true"
                :autoplayHoverPause="true"
                :navText="['<','>']"
                :responsive="{0:{items:1},576:{items:1},768:{items:2}, 1024:{items:2}, 1200:{items:2}, 1440:{items:3}, 1600:{items:3},1700:{items:4}}"
            >
              <div class="carousel_item" v-for="(review, index) in allReviews" :key="index">
                <h3 class="carousel_item-name">{{ review.first_name }} {{ review.last_name }}</h3>
                <div class="carousel_item-stars"></div>
                <p class="carousel_item-description">{{ review.message }}</p>
              </div>
            </carousel>
          </div>
        </div>
      </section>
      <section>
        <div class="main_section questions">
          <h3 class="main_section-title">Frequently asked questions</h3>
          <div class="questions_content">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab"
                   aria-controls="pills-home" aria-selected="true">For Guests</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="pills-home-tab1" data-toggle="pill" href="#pills-home" role="tab"
                   aria-controls="pills-home" aria-selected="true">For Hosts</a>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                <div class="tab_block">
                  <h4 class="tab_block-name">How do I book a property?</h4>
                  <p class="tab_block-description">Simply search for your desired location and dates, browse available
                    properties, and click "Book
                    Now." You can securely pay and receive instant confirmation.</p>
                  <h4 class="tab_block-name">What payment methods do you accept?</h4>
                  <p class="tab_block-description">We accept all major credit cards, PayPal, and Stripe for secure
                    transactions. Your payment details are always protected.</p>
                  <h4 class="tab_block-name">How do I contact the property host?</h4>
                  <p class="tab_block-description">After booking, you can message the host directly through our
                    platform's messaging system to ask questions or arrange details like check-in times.</p>
                </div>
                <div class="tab_block">
                  <h4 class="tab_block-name">Can I book directly through the website instead ?</h4>
                  <p class="tab_block-description">Yes, you can book directly on our platform and avoid additional fees.
                    Our direct booking system is
                    secure and gives you access to the same great properties.</p>

                  <h4 class="tab_block-name">What is the cancellation policy?</h4>
                  <p class="tab_block-description">Cancellation policies vary by property and are clearly stated on each
                    listing. Please review the policy before booking to understand any fees or deadlines.</p>

                  <h4 class="tab_block-name">Can I make changes to my booking?</h4>
                  <p class="tab_block-description">Yes, you can request changes like modifying dates or guest count, but
                    it's subject to the host's approval. Log in to your account to manage your bookings.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar";
import carousel from 'vue-owl-carousel'
import Footer from "@/components/Footer";
import {mapActions} from "vuex";
import emptyImg from '../assets/images/no_image.png'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'HomeView',
  data() {
    return {
      filter_value: [],
      searchUrl: "",
      amenities_options: [
        {name: 'Free WiFi', val: 'freeWiFi'},
        {name: 'Hot tub', val: 'hotTub'},
        {name: 'Beach front', val: 'beachFront'},
        {name: 'Air condition', val: 'airCondition'},
        {name: 'Kitchen', val: 'kitchen'},
        {name: 'Pets allowed', val: 'petsAllowed'},
        {name: 'Street parking', val: 'streetParking'},
        {name: 'Suitable for children', val: 'suitableForChildren'},
        {name: 'Swimming pool', val: 'swimmingPool'},
        {name: 'Washing machine', val: 'washingMachine'},
      ],
      emptyImg: emptyImg,
      liked: false,
      searchData: {
        city: '',
        start: null,
        end: null,
        numberOfGuests: 1
      },
      serchResults: [],
      allHomeListings: [],
      result_error: '',
      allReviews: [],
      allBlogs: [],
      showSuggestions: false,
      citySuggestions: [],
      mapboxToken: 'pk.eyJ1IjoibWluZ3lhbjIxNCIsImEiOiJja2h4Y2xiajAwMTBsMnZuNHBzMjVmYjlsIn0.w7Wxvvi2i4olHVL2gE1zkQ'
    }
  },
  components: {
    Footer,
    NavBar,
    carousel,
    Multiselect
  },
  watch: {
    'searchData.start'(newStart) {
      if (this.searchData.end && this.searchData.end < newStart) {
        this.searchData.end = newStart;
      }
    },
    'searchData.end'(newEnd) {
      if (this.searchData.start && this.searchData.start > newEnd) {
        this.searchData.start = newEnd;
      }
    }
  },
  computed: {
    last15Days() {
      const today = new Date();
      const pastDate = new Date();
      pastDate.setDate(today.getDate() - 15);
      const options = { month: 'short', day: 'numeric' };

      const from = pastDate.toLocaleDateString('en-US', options);
      const to = today.toLocaleDateString('en-US', options);

      return `${from} - ${to}`;
    },
    today() {
      return new Date().toISOString().split("T")[0];
    },
    startDate: {
      get() {
        return this.searchData.start;
      },
      set(value) {
        this.searchData.start = value || " ";
      }
    },
    endDate: {
      get() {
        return this.searchData.end;
      },
      set(value) {
        this.searchData.end = value || " ";
      }
    }
  },
  created() {
    let unique = localStorage.getItem('unique_hash')
    let listingDetails = localStorage.getItem('listingDetails')
    if (unique) {
      localStorage.removeItem('unique_hash')
    }
    if (listingDetails) {
      localStorage.removeItem('listingDetails')
    }
    this.getAllReviews()

    this.getHomeListings()

    this.getBlogs()
  },
  methods: {
    ...mapActions(['doSearch', 'reviewsGet', 'getAllHomeListings', 'getAllBlogs']),
    showListing(item) {
      item.guests = this.searchData.numberOfGuests
      const id = item.id || item.listing_id
      this.$router.push({
        name: "ListingCalendar",
        params: { data: item },
        query: id ? { id } : {}
      })
    },
    onSelect() {
      setTimeout(() => {
        this.result_error = '';
        let send_data = {
          city: this.searchData.city,
          start: this.searchData.start == null ? "" : this.searchData.start,
          end: this.searchData.end == null ? "" : this.searchData.end,
          numberOfGuests: this.searchData.numberOfGuests
        };
        // Add amenities as separate params with value = 1
        this.filter_value.forEach(item => {
          send_data[item.val] = 1;
        });

        if (send_data.numberOfGuests != 0) {
          this.doSearch(send_data).then(res => {
            if(res !== undefined) {
              this.serchResults = res.data.data;
            }
            if (this.serchResults.length) {
              this.$nextTick(() => {
                this.scrollToElement();
                window.scrollTo({ top: 800, behavior: 'smooth' });
              });
            } else {
              this.result_error = 'No listings found. Please try a different search.';
            }
          })
          .catch(err => {
            if(err) {
              this.result_error = 'No listings found. Please try a different search.';
            }
          })
        } else {
          this.result_error = 'Add guests';
        }
      }, 300);
    },

    showListingsByCategory(category) {
      const categoryName = category && category.category ? category.category : category
      this.$router.push({
        name: "CategoryListings",
        params: { category: category },
        query: { category: categoryName }
      })
    },
    formatAddress(item) {
      if (!item) return ''
      const addr = item.address || item || {}
      const parts = []

      if (addr.city) {
        parts.push(addr.city)
      }

      const zip = addr.zip_code || addr.postal_code
      const stateZip = [addr.state, zip].filter(Boolean).join(' ')
      if (stateZip) {
        parts.push(stateZip)
      }

      if (addr.country) {
        parts.push(addr.country)
      }

      if (parts.length) {
        return parts.join(', ')
      }

      // Fallbacks if structured fields are missing
      if (addr.address) return addr.address
      if (addr.public_address) return addr.public_address
      return ''
    },
    getCurrencySymbol(currencyCode) {
      try {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        // Extract symbol by formatting a value and removing the digits
        const parts = formatter.formatToParts(1);
        const symbolPart = parts.find(part => part.type === 'currency');
        return symbolPart ? symbolPart.value : currencyCode;
      } catch (e) {
        return currencyCode; // fallback if the currency code is invalid
      }
    },
    scrollToElement() {
      const el = this.$refs['search_results'];
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    getAllReviews() {
      this.reviewsGet()
          .then(res => {
            this.allReviews = res.data.data
          })

    },
    async onInputCity() {
      if (!this.searchData.city || this.searchData.city.length < 2) {
        this.citySuggestions = [];
        return;
      }

      const url = `https://nominatim.openstreetmap.org/search?city=${encodeURIComponent(this.searchData.city)}&format=json&addressdetails=1&limit=10&accept-language=en`;
      // const endpoint = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
      //     this.searchData.city
      // )}.json?access_token=${this.mapboxToken}&autocomplete=true&types=place`;
      try {
        const response = await fetch(url, {
          headers: { "User-Agent": "YourAppName" }
        });
        const data = await response.json();
        this.citySuggestions = data.map(item => ({
          place_name: `${item.display_name}`,
          text: item.address.city || item.address.town || item.address.village
        }));
      } catch (error) {
        console.error("Nominatim error:", error);
        this.citySuggestions = [];
      }
    },
    selectCity(suggestion) {
      this.searchData.city = suggestion.text; // or suggestion.place_name
      this.showSuggestions = false;
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 100);
    },
    getHomeListings() {
      this.getAllHomeListings()
          .then(res => {

            this.allHomeListings = res.data
          })
    },
    getBlogs() {
      this.getAllBlogs()
          .then(res => {
            this.allBlogs = res.data.data
          })
    },
    viewAllPosts() {
      this.$router.push('/blogs')
    },
    routToBlog(blog) {
      this.$router.push({name: "Blog", params: {id: blog.id}})
    }
  }
}
</script>
<style scoped lang="scss">
.main {
  &_container {
    & .result_error-text {
      color: red;
      position: absolute;
      bottom: -5px;
      font-size: 18px;
      font-weight: 600;
      @media screen and (max-width: 420px) {
        font-size: 13px;
        bottom: 22px;
      }
    }

  }

  &_home {
    &-background {
      width: 100%;
      height: 900px;
      background: url("~@/assets/images/home_background.png") no-repeat center;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 1680px) {
        height: 800px;
      }
      @media screen and (max-width: 1024px) {
        background-size: cover;
      }
      @media screen and (max-width: 420px) {
        height: 760px;
      }
    }

    &-content {
      position: absolute;
      margin: 0 auto;
      bottom: 15%;
      width: 830px;
      height: 610px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-radius: 500px 500px 0px 0px;
      border-top: 2px solid #FFF;
      border-bottom: 2px solid #FFF;
      border-left: 2px solid #FFF;
      background: rgba(0, 0, 0, 0.50);
      @media screen and (max-width: 1680px) {
        width: 830px;
        height: 500px;
        padding: 40px 40px 40px 100px;
      }
      @media screen and (max-width: 1440px) {
        width: 800px;
        height: 400px;
        padding: 30px 30px 30px 60px;
      }
      @media screen and (max-width: 768px) {
        width: 600px;
        height: 300px;
        padding: 25px;
        left: 0;
        right: 0;
        justify-content: end;
      }
      @media screen and (max-width: 540px) {
        width: 100%;
        height: 250px;
      }
      @media screen and (max-width: 440px) {
        bottom: 20px;
        padding: 20px;
        justify-content: center;
      }
    }

    &-title {
      color: #fff;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      text-align: center;
      line-height: normal;
      padding-bottom: 30px;
      max-width: 545px;
      @media screen and (max-width: 1680px) {
        font-size: 28px;
      }
      @media screen and (max-width: 1440px) {
        font-size: 25px;
      }
      @media screen and (max-width: 768px) {
        font-size: 17px;
        font-weight: 600;
        padding-bottom: 20px;
      }
      @media screen and (max-width: 440px) {
        max-width: 300px;
        font-size: 15px;
      }
    }

    &-description {
      max-width: 545px;
      text-align: center;
      color: #fff;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      @media screen and (max-width: 1680px) {
        font-size: 20px;
      }
      @media screen and (max-width: 1440px) {
        font-size: 18px;
      }
      @media screen and (max-width: 768px) {
        font-size: 15px;
      }
      @media screen and (max-width: 440px) {
        font-size: 14px;
      }
    }

    &-btn {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      & svg {
        cursor: pointer;

        &:hover path {
          fill: #068BD6;
        }
      }
    }
  }

  &_search {
    &-container {
      width: 100%;
      position: absolute;
      bottom: 10%;
      margin: 0 auto;
      padding: 50px 0 20px;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 768px) {
        bottom: 30%;
      }
      @media screen and (max-width: 420px) {
        bottom: 35%;

      }
    }

    &-block {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 40px;
      border: 1px solid #D9D9D9;
      background: #fff;
      box-shadow: 0 4px 20px 0 rgba(30, 30, 30, 0.08);
      padding: 10px 30px;
      @media screen and (max-width: 1024px) {
        padding: 8px;
        height: 62px;
      }
      @media screen and (max-width: 768px) {
        height: auto;
        flex-direction: column;
        max-width: 300px;
        padding: 20px;
      }


      & .input_divider {
        width: 2px;
        height: 40px;
        border-radius: 20px;
        background: #D9D9D9;
        margin-right: 10px;
        @media screen and (max-width: 768px) {
          width: 95%;
          height: 6px;
          margin: 5px 0;
        }
      }
    }

    &-box {
      display: flex;
      flex-direction: column;
      padding: 0 7px;
      @media screen and (max-width: 1024px) {
        padding: 0 5px;
      }
      @media screen and (max-width: 768px) {
        width: 100%;

      }

      &:nth-child(1) {
        margin-left: 10px;
        @media screen and (max-width: 768px) {
          margin-left: 0;
        }

        & input {
          width: 240px;
          @media screen and (max-width: 1024px) {
            width: 200px;
            margin-top: 3px;

          }
        }
      }

      & label {
        color: #1E1E1E;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        @media screen and (max-width: 1024px) {
          margin-bottom: 4px;
        }
      }

      & input {
        border: none;
        width: 140px;
        margin-top: 5px;
        @media screen and (max-width: 1024px) {
          width: 120px;
          margin-top: 3px;
        }

        &:focus-visible {
          outline: none;
        }
      }
    }

    &-btn {
      width: 50px;
      height: 50px;
      border: none;
      outline: none;
      background: url("~@/assets/icons/main_search.svg");
      @media screen and (max-width: 768px) {
        margin-top: 20px;
      }
    }
  }

  &_sub {
    position: absolute;
    width: 100%;
    bottom: 5%;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: center;
    @media screen and (max-width: 1024px) {
      font-size: 18px;
    }
    @media screen and (max-width: 540px) {
      padding: 0 20px;
      font-size: 16px;
    }

    &-icon {
      display: flex;
      justify-content: center;
      width: 9px;
      height: 9px;
      background: url("~@/assets/icons/sub_icon.svg");
    }
  }

  &_section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 90px 0 50px;
    @media screen and (max-width: 1680px) {
      padding: 60px 0 30px;
    }
    @media screen and (max-width: 1024px) {
      padding: 40px 0 20px;
    }
    @media screen and (max-width: 768px) {
      padding: 20px 0;

    }

    &-title {
      color: #000;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      padding-bottom: 30px;
      @media screen and (max-width: 1680px) {
        font-size: 32px;
      }
      @media screen and (max-width: 1440px) {
        padding-bottom: 20px;
      }
      @media screen and (max-width: 1024px) {
        font-size: 28px;
      }
      @media screen and (max-width: 540px) {
        font-size: 24px;
      }
      @media screen and (max-width: 440px) {
        font-size: 20px;
        padding-bottom: 10px;
      }
    }

    &-view {
      cursor: pointer;
      color: #068BD6;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }

    &.offer {
      & .offer {
        &_background {
          width: 90%;
          height: 480px;
          background: url("~@/assets/images/offer_bg.png") no-repeat center;
          background-size: cover;
          border-radius: 8px;
          @media screen and (max-width: 768px) {
            max-height: 400px;
          }
          @media screen and (max-width: 440px) {
            max-height: 360px;

          }
        }

        &_layer {
          border-radius: 8px 0 0 8px;
          display: flex;
          width: 547px;
          height: 480px;
          padding: 40px;
          flex-direction: column;
          align-items: flex-start;
          background: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.10) 100%);
          backdrop-filter: blur(5px);
          @media screen and (max-width: 1440px) {
            width: 500px;
            height: 100%;
          }
          @media screen and (max-width: 768px) {
            width: 360px;
          }
          @media screen and (max-width: 440px) {
            width: 260px;
            padding: 20px;
          }
        }

        &_title {
          color: #FFF;
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 48px;
          margin-bottom: 25px;
          @media screen and (max-width: 1440px) {
            font-size: 26px;
            margin-top: 40px;
          }
          @media screen and (max-width: 768px) {
            font-size: 20px;
            margin-top: 30px;
          }
          @media screen and (max-width: 440px) {
            margin-top: 20px;

          }
        }

        &_description {
          color: #FFF;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          @media screen and (max-width: 1440px) {
            line-height: 20px;
          }
          @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 18px;
          }
          @media screen and (max-width: 440px) {
            font-size: 14px;
            line-height: 16px;

          }
        }

        &_discover-btn {
          margin: 40px 0;
          border: none;
          color: var(--Gray-Colors-White, #FFF);
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          padding: 16px 24px;
          border-radius: 30px;
          background: #068BD6;
          @media screen and (max-width: 1440px) {
            padding: 14px 20px;
            font-size: 18px;
            font-weight: 5600;
          }
          @media screen and (max-width: 768px) {
            font-size: 16px;
          }
        }

        &_items {
          display: flex;
          max-width: 100%;
          overflow: hidden;
          @media screen and (max-width: 1440px) {
            padding: 5px 50px 20px;
            overflow-x: scroll;
          }

          & .carousel-item {
            width: 263px;
            height: 263px;
            margin: 0 !important;
            position: relative;
            @media screen and (max-width: 1680px) {
              width: 240px;
              height: 240px;
            }

            &.carousel-item-next,
            &.carousel-item-prev {
              width: 263px;
              height: 263px;
              position: absolute;
              @media screen and (max-width: 1680px) {
                width: 240px;
                height: 240px;
              }
            }
          }
        }

        &_carousel {
          &-item {
            margin: 0 10px;
            position: relative;
            border: 1px solid #e6e8e7;
            border-radius: 20px;

            &:hover {
              cursor: pointer;
            }

            ::v-deep .empty_slide {
              background: #e6e8e7;
              border-radius: 20px;
            }

            ::v-deep .img-fluid {
              height: 100%;
              object-fit: cover;
              border-radius: 15px;
            }

            ::v-deep .carousel-indicators {
              & li {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                fill: rgba(217, 217, 217, 0.60);
              }
            }

            ::v-deep .carousel-caption {
              position: initial;
            }

            & .offer_like {
              width: 15px;
              height: 15px;
              background: url("~@/assets/icons/offer_like.svg") no-repeat center;
              background-size: contain;
              position: absolute;
              top: 10px;
              right: 10px;

              &.liked {
                background: url("~@/assets/icons/like_red.svg") no-repeat center;
                background-size: contain;
              }
            }
          }
        }
      }
    }

    &.top_deals {
      align-items: start;
      max-width: 100%;
      padding: 90px 100px 50px;
      @media screen and (max-width: 768px) {
        padding: 40px;
      }
      @media screen and (max-width: 440px) {
        padding: 20px;

      }
      & .select_content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        ::v-deep .multiselect {
          min-width: 330px;
          width: auto;
          cursor: pointer;
        }
      }
      & .select_box {
        width: 720px;
        display: flex;
        justify-content: flex-end;
        @media screen and (max-width: 1024px) {
          width: 400px;
        }
      }

      & .top {
        &_title {
          color: #000;
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 48px; /* 150% */
          @media screen and (max-width: 1440px) {
            line-height: 38px;
          }
          @media screen and (max-width: 1024px) {
            font-size: 26px;
            line-height: 30px;
          }
          @media screen and (max-width: 440px) {
            font-size: 20px;
          }

        }

        &_sub {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          &-date {
            color: #000;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px;
            @media screen and (max-width: 440px) {
              font-size: 15px;

            }
          }

          &-all {
            color: #068BD6;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            cursor: pointer;
          }
        }

        &_deals {
          display: flex;
          max-width: 100%;
          overflow: hidden;
          padding: 15px 0;
          @media screen and (max-width: 1680px) {
            //justify-content: space-between !important;
            width: 100%;
          }
          @media screen and (max-width: 1024px) {
            //justify-content: space-evenly !important;
            //flex-wrap: wrap !important;
            width: 100%;
          }

          & .carousel-item {
            width: 405px;
            height: 605px;
            margin: 0 !important;
            position: relative;
            @media screen and (max-width: 1680px) {
              width: 340px;
              height: 450px;
            }
            @media screen and (max-width: 1440px) {
              width: 280px;
              height: 400px;
            }
            &.carousel-item-next {
              width: 405px;
              height: 605px;
              @media screen and (max-width: 1680px) {
                width: 340px;
                height: 450px;
              }
              @media screen and (max-width: 1440px) {
                width: 280px;
                height: 400px;
              }
            }

            &.carousel-item-next,
            &.carousel-item-prev {
              width: 405px;
              height: 605px;
              position: absolute;
              @media screen and (max-width: 1680px) {
                width: 340px;
                height: 450px;
              }
              @media screen and (max-width: 1440px) {
                width: 280px;
                height: 400px;
              }
              //@media screen and (max-width: 1680px) {
              //  width: 240px;
              //  height: 240px;
              //}
            }
          }
        }

        &_carousel {
          &-item {
            margin: 0 10px;
            position: relative;
            border-radius: 15px;
            @media screen and (max-width: 1024px) {
              margin: 10px;
            }

            .carousel {
              &-info {
                &-overlay {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 190px;
                  background: rgba(255, 255, 255, 0.50);
                  backdrop-filter: blur(7.5px);
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  padding: 24px 24px 40px 24px;
                  box-sizing: border-box;
                  z-index: 2;
                  border-radius: 0 0 15px 15px;
                  @media screen and (max-width: 1440px) {
                    height: 170px;
                    justify-content: space-between;
                    padding: 15px;
                  }
                }

                &-content {
                  color: black;
                  text-align: start;
                  font-weight: 500;
                  @media screen and (max-width: 1440px) {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  }
                }
              }

              &-title {
                font-size: 18px;
                font-weight: bold;
                margin: 0;
                @media screen and (max-width: 1440px) {
                  font-size: 16px;
                }
              }

              &-text {
                margin: 5px 0;
                font-size: 14px;
              }

              &-price {
                margin: 24px 0 8px;
                font-weight: 600;
                line-height: 24px;
                @media screen and (max-width: 1440px) {
                  margin: 12px 0 4px;
                  line-height: 20px;
                }
              }
            }

            &:hover {
              cursor: pointer;
            }

            ::v-deep .empty_slide {
              background: #e6e8e7;
              border-radius: 15px;
            }

            ::v-deep .img-fluid {
              height: 100%;
              object-fit: cover;
              border-radius: 15px;
            }

            ::v-deep .carousel-indicators {
              bottom: 190px;

              & li {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                fill: rgba(217, 217, 217, 0.60);
              }
            }

            ::v-deep .carousel-caption {
              position: initial;
            }

            & .offer_like {
              width: 15px;
              height: 15px;
              background: url("~@/assets/icons/offer_like.svg") no-repeat center;
              background-size: contain;
              position: absolute;
              top: 10px;
              right: 10px;

              &.liked {
                background: url("~@/assets/icons/like_red.svg") no-repeat center;
                background-size: contain;
              }
            }
          }
        }
      }

      &.category {
        & .carousel-item {
          width: 405px;
          height: 485px;
          margin: 0 !important;
          position: relative;
          @media screen and (max-width: 1680px) {
            width: 340px;
            height: 400px;
          }
          @media screen and (max-width: 1440px) {
            width: 280px;
            height: 320px;
          }

          & .carousel-info-overlay {
            height: 75px;
          }
        }
      }
    }

    &.news {
      align-items: start;
      max-width: 100%;
      padding: 90px 100px 50px;
      @media screen and (max-width: 768px) {
        padding: 40px;
      }
      @media screen and (max-width: 440px) {
        padding: 20px;
      }

      & .news {
        &_box {
          &-container {
            display: flex;
            max-width: 100%;
            width: 100%;
            overflow: hidden;
            flex-wrap: wrap;
            justify-content: space-around;
            @media screen and (max-width: 1440px) {
              padding: 20px 10px;
            }
            @media screen and (max-width: 1024px) {
              width: 100%;
              justify-content: space-around;
            }
          }

          &-item {
            border-radius: 12px;
            padding: 16px;
            width: 550px;
            margin: 0 10px;
            @media screen and (max-width: 1680px) {
              max-width: 320px;
            }
            @media screen and (max-width: 1440px) {
              max-width: unset;
              width: 280px;
              padding: 10px;
            }
            @media screen and (max-width: 1024px) {
              margin: 0 10px;
              width: 300px;
            }

            & .item_img {
              width: 100%;
              @media screen and (max-width: 1680px) {
                width: 100%;
              }
            }

            &.blogs {
              width: 400px;
              cursor: pointer;
              @media screen and (max-width: 1440px) {
                width: 280px;
              }

              & .item_img {
                width: 365px;
                height: 200px;
                @media screen and (max-width: 1440px) {
                  width: 280px;
                  height: 200px;
                }
              }

            }
          }

          &-description {
            color: #000;
            font-size: 22px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            padding: 4px 8px;
            max-width: 550px;
            @media screen and (max-width: 1680px) {
              font-size: 20px;
              max-width: 100%;
            }
            @media screen and (max-width: 1440px) {
              font-size: 16px;
              line-height: 22px;
            }
            @media screen and (max-width: 1024px) {
              font-size: 16px;
              line-height: 20px;
            }
          }

        }
      }
    }

    &.reviews {
      & .reviews {
        &_content {
          max-width: 88%;
          width: 100%;
          display: flex;
          //overflow-x: hidden;
          //background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 12%, rgba(255, 255, 255, 0) 88%, rgba(255, 255, 255, 1) 100%);
          & > div {
            width: 100%;
          }

          ::v-deep .owl-carousel {
            display: flex !important;
            justify-content: space-around;
            & .owl-item {
              @media screen and (max-width: 440px) {
                margin-left: 8px;
              }
            }
            & .owl-stage-outer {
              @media screen and (max-width: 440px) {
                height: 220px;
              }
            }
          }

          @media screen and (max-width: 768px) {
            max-width: 95%;
          }
          @media screen and (max-width: 440px) {
            max-width: 100%;
          }

          ::v-deep .owl-nav {
            position: absolute;
            top: 100px;
            width: 100%;
            display: flex;
            justify-content: space-between;

            & .owl-prev,
            & .owl-next {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #068BD6;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              line-height: 22px;
              font-weight: 700;
            }

            & .owl-prev {
              box-shadow: -50px 0px 40px 85px #ffffff;
               @media screen and (max-width: 440px) {
                 box-shadow: -50px 0px 40px 60px #ffffff;
               }
            }
            & .owl-next {
              box-shadow: 50px 0px 40px 85px #ffffff;
              @media screen and (max-width: 440px) {
                box-shadow: 50px 0px 40px 60px #ffffff;

              }

            }
          }

          & .carousel {
            &_item {
              width: 390px;
              height: 260px;
              padding: 20px;
              border-radius: 10px;
              border: 1px solid #B0B0B0;
              margin: 0 10px;
              @media screen and (max-width: 768px) {
                width: 300px;
                height: 200px;
                padding: 10px 15px;
              }

              &-name {
                color: #000;
                font-size: 20px;
                font-style: normal;
                font-weight: 900;
                line-height: normal;
                @media screen and (max-width: 768px) {
                  margin-top: 5px;
                  margin-bottom: 5px;
                }
              }

              &-stars {
                width: 80px;
                height: 38px;
                background: url("~@/assets/icons/stars_icon.svg");
                @media screen and (max-width: 768px) {
                  height: 33px;
                }
              }

              &-description {
                color: #181A2A;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
                display: -webkit-box;
                -webkit-line-clamp: 6;
                -webkit-box-orient: vertical;
                overflow: hidden;
                @media screen and (max-width: 768px) {
                  font-size: 14px;
                  line-height: 16px;
                }
              }
            }
          }
        }
      }
    }

    &.questions {
      & .questions {
        &_content {
          width: 85%;
          display: flex;
          flex-direction: column;
          align-items: center;
          @media screen and (max-width: 1440px) {
            width: 80%;
          }
          @media screen and (max-width: 768px) {
            width: 90%;
          }
          @media screen and (max-width: 540px) {
            width: 95%;
          }

          & .nav {
            &-pills {
            }

            &-item {
            }

            &-link {
              background: transparent;
              color: #1E1E1E;
              text-align: center;
              font-size: 36px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              border-radius: 0;

              &.active {
                font-weight: 900;
                border-bottom: 4px solid #068BD6;
              }

              @media screen and (max-width: 540px) {
                font-size: 22px;
              }
            }
          }

          & .tab {
            &-pane {
              display: none;

              &.active {
                display: flex;
              }
            }

            &_block {
              padding: 60px 50px 10px;
              max-width: 780px;
              @media screen and (max-width: 1680px) {
                padding: 40px 35px 10px;
              }
              @media screen and (max-width: 1440px) {
                padding: 30px 20px 10px;
                max-width: 560px;
              }
              @media screen and (max-width: 540px) {
                padding: 20px 10px 0;
              }

              &-name {
                color: #000;
                font-size: 24px;
                font-weight: 900;
                line-height: normal;
                padding-bottom: 20px;
                @media screen and (max-width: 1680px) {
                  font-size: 22px;
                }
                @media screen and (max-width: 1440px) {
                  font-size: 20px;
                  padding-bottom: 15px;
                }
                @media screen and (max-width: 1024px) {
                  font-size: 18px;
                  padding-bottom: 10px;
                }
                @media screen and (max-width: 540px) {
                  font-size: 17px;
                }
                @media screen and (max-width: 440px) {
                  font-size: 15px;
                }
              }

              &-description {
                color: #000;
                font-size: 24px;
                font-weight: 400;
                line-height: normal;
                padding-bottom: 70px;
                @media screen and (max-width: 1680px) {
                  font-size: 22px;
                }
                @media screen and (max-width: 1440px) {
                  font-size: 20px;
                  padding-bottom: 50px;
                }
                @media screen and (max-width: 1024px) {
                  font-size: 18px;
                  padding-bottom: 40px;
                }
                @media screen and (max-width: 540px) {
                  font-size: 16px;
                  padding-bottom: 30px;
                }
                @media screen and (max-width: 440px) {
                  font-size: 14px;
                  padding-bottom: 20px;
                }
              }
            }
          }
        }
      }
    }
    ::v-deep .top_deals {
      &.search_results {
        & .owl-nav {
          display: flex;
        }
        & .owl-item {
          display: flex;
          flex-shrink: 0;
          width: 100% !important;
          
          &.cloned {
            display: none !important;
          }
          
          & .top_carousel-item {
            width: 100%;
            height: 605px;
            flex: 0 0 auto;
            margin: 0 10px;
            
            @media screen and (max-width: 1680px) {
              height: 450px;
            }
            @media screen and (max-width: 1440px) {
              height: 400px;
            }
            @media screen and (max-width: 1024px) {
              height: 400px;
              margin: 10px;
            }
          }
        }
        
        & .owl-stage {
          display: flex;
          align-items: stretch;
          width: 100% !important;
        }
        
        & .owl-stage-outer {
          overflow: hidden;
        }
      }
    }
  }

  &_app {
    &-container {
      margin-top: 90px;
      width: 100%;
      height: 1000px;
      background: url("~@/assets/images/app_background.png") no-repeat center;
      @media screen and (max-width: 1680px) {
        margin-top: 70px;
        height: 800px;
      }
      @media screen and (max-width: 1440px) {
        height: 700px;
        background-size: cover;
      }
      @media screen and (max-width: 1024px) {
        height: 560px;
      }
    }

    &-content {
      padding: 120px;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      align-items: flex-end;
      @media screen and (max-width: 1680px) {
        padding: 70px;
      }
      @media screen and (max-width: 1440px) {
        padding: 50px;
      }
      @media screen and (max-width: 540px) {
        padding: 20px;
      }
    }

    &-title {
      color: #FFF;
      text-align: right;
      font-size: 64px;
      font-style: normal;
      font-weight: 400;
      line-height: 100px;
      @media screen and (max-width: 1680px) {
        font-size: 54px;
      }
      @media screen and (max-width: 1440px) {
        font-size: 42px;
      }
      @media screen and (max-width: 1024px) {
        font-size: 32px;
        line-height: 50px;
      }
      @media screen and (max-width: 540px) {
        font-size: 22px;
        line-height: 30px;
      }
    }

    &-subtitle {
      color: #FFF;
      text-align: right;
      font-size: 64px;
      font-style: normal;
      font-weight: 900;
      line-height: 100px;
      @media screen and (max-width: 1680px) {
        font-size: 54px;
      }
      @media screen and (max-width: 1440px) {
        font-size: 42px;
      }
      @media screen and (max-width: 1024px) {
        font-size: 32px;
        line-height: 50px;
      }
      @media screen and (max-width: 540px) {
        font-size: 24px;
        line-height: 35px;
      }
    }

    &-description {
      color: #FFF;
      text-align: right;
      font-size: 32px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px;
      max-width: 680px;
      padding: 60px 0;
      @media screen and (max-width: 1680px) {
        font-size: 28px;
        padding: 30px 0;
        max-width: 600px;
      }
      @media screen and (max-width: 1440px) {
        max-width: 500px;
        font-size: 18px;
        padding: 20px 0;
      }
      @media screen and (max-width: 1024px) {
        font-size: 16px;
      }
      @media screen and (max-width: 540px) {
        max-width: 240px;
        font-size: 14px;
        line-height: 30px;
      }
    }

    &-btn {
      background: transparent;
      padding: 10px 30px;
      color: #FFF;
      text-align: right;
      font-size: 32px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border-radius: 68px;
      border: 1px solid #B0B0B0;
      @media screen and (max-width: 1024px) {
        font-size: 22px;
      }
      @media screen and (max-width: 540px) {
        font-size: 18px;
      }

      &:hover {
        background: transparent;
      }
    }

    &-products {
      margin-top: 100px;
      width: 165px;
      height: 120px;
      background: url("~@/assets/images/products.png");
      @media screen and (max-width: 1680px) {
        margin-top: 70px;
      }
      @media screen and (max-width: 540px) {
        margin-top: 60px;
        width: 140px;
        height: 100px;
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
}

input[type='number'] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.autocomplete-box {
  position: relative;
}

.autocomplete-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style: none;
}

.autocomplete-list li {
  padding: 8px 12px;
  cursor: pointer;
}

.autocomplete-list li:hover {
  background-color: #f0f0f0;
}
.info-datepicker .md-input {
  background-color: #2196f3 !important;
  color: #fff !important;
  border-radius: 4px;
}
</style>
